import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { QFilterModel } from '../../../../models/qfilter.model';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-list-customer-value',
  templateUrl: './list-customer-value.component.html',
  styleUrls: ['./list-customer-value.component.css']
})

// Pagina 23
export class ListCustomerValueComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public segmentDistribution: LoyaltyChart;
  public penetrationLoyalty: LoyaltyChart;
  public data: QFilterModel;

  constructor (
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {

    this.translations = {
      segmentDistributionChartTitle: '',
      penetrationLoyaltyChartTitle: '',
      seg_chart_y_title: '',
      pen_chart_y_title: ''
    };

    this.translate.get([
      'customerVaueChart.segmentDistributionChartTitle',
      'customerVaueChart.penetrationLoyaltyChartTitle',
      'customerVaueChart.segment_y_title',
      'customerVaueChart.penetration_y_title'
    ]).subscribe((t) => {
      this.translations = {
        segmentDistributionChartTitle: t['customerVaueChart.segmentDistributionChartTitle'],
        penetrationLoyaltyChartTitle: t['customerVaueChart.penetrationLoyaltyChartTitle'],
        seg_chart_y_title: t['customerVaueChart.segment_y_title'],
        pen_chart_y_title: t['customerVaueChart.penetration_y_title']
      };

      this.initCharts();
    });
  }

  initCharts() {
    this.segmentDistribution = new LoyaltyChart('bar');
    this.segmentDistribution.options.chart.marginTop = 50;
    this.segmentDistribution.options.yAxis = {labels: {formatter: function() { return this.value + ' %'; }}};
    this.segmentDistribution.options.yAxis.title = { text : this.translations.seg_chart_y_title };
    this.segmentDistribution.options.plotOptions = {series: {stacking: 'percent'}};
    this.segmentDistribution.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom', reversed: true};
    this.segmentDistribution.options.tooltip = {
      formatter: function () {
        return '<b>' + NumberKMPipe.formatDynamic(this.y, '') + '</b> (' + NumberKMPipe.formatDynamic(this.percentage, '%') + ')';
      }
    };


    this.penetrationLoyalty = new LoyaltyChart('bar');
    this.penetrationLoyalty.options.chart.marginTop = 50;
    this.penetrationLoyalty.options.xAxis = {type: 'category'};
    this.penetrationLoyalty.options.yAxis = {labels: {formatter: function() { return this.value + ' %'; }}};
    this.penetrationLoyalty.options.yAxis.title = { text : this.translations.pen_chart_y_title };
    this.penetrationLoyalty.options.legend.enabled = false;
    this.penetrationLoyalty.options.tooltip = {formatter: function() { return '<b>' + this.y + '%</b>'; }};

  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    Observable.zip(
      this.indicatorService.indicatorCalculation('stores.Q071', this.data),
      this.indicatorService.indicatorCalculation('stores.Q143', this.data),
      this.indicatorService.indicatorCalculation('stores.Q144', this.data)
    ).subscribe(
      ([a, b, c]) => {

        /*071*/
        this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'numero_negozi')], {dynamic: true, decimal_value: 0, decimal_prec_value: 0}));
        /*143*/
        this.indicators.push(new IndicatorBoxModel([b.find(r => r.name === 'n_clienti')], {dynamic: true, decimal_value: 0, decimal_prec_value: 0}));
        /*071*/
        this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'fatturato')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
        /*144*/
        this.indicators.push(new IndicatorBoxModel([c.find(r => r.name === 'fatturato_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      });

    this.segmentDistributionInit (data);
    this.penetrationLoyaltyInit (data);
    this.show_results = true

  }

  segmentDistributionInit (data) {
    Observable.zip (
      this.indicatorService.getChart('stores.Q145', data, false),
      this.indicatorService.getChart('stores.Q145B', data, false)
    ).subscribe( ([res, resMedia]) => {


      let serie0 = resMedia.series[0].serie.concat(res.series[0].serie);
      let serie1 = resMedia.series[1].serie.concat(res.series[1].serie);
      let serie2 = resMedia.series[2].serie.concat(res.series[2].serie);
      let colors = resMedia.series[3].serie;

      const xAxis = {
        serie: serie0.filter(function (value, indice, self) {
          return self.indexOf(value) === indice;
        })
      };

      let unique = serie1.filter( function (value, indice, self) {
        return self.indexOf(value) === indice;
      });

      let index = unique.length;
      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let item = series.find(function (elemento) {
          return elemento.name === serie1[i];
        });

        if (typeof item === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]], index: index, color: colors[(i)]});
          index = index - 1;
        } else {
          item.data.push(serie2[i]);
        }
      }

      if (typeof series[0] !== 'undefined') {
        this.segmentDistribution.options.chart.height = this.computeHeight(series[0].data.length);
      }

      this.segmentDistribution.options.chart.marginBottom = 130;

      if (this.segmentDistribution.instance) {
        while (this.segmentDistribution.instance.series.length > 0) {
          this.segmentDistribution.instance.series[0].remove(true);
        }
      }

      this.segmentDistribution.options.xAxis.categories = xAxis.serie;

      for (let i = 0; i < series.length; i++) {

        this.segmentDistribution.instance.addSeries(series[i]);
      }

      this.segmentDistribution.instance.update(this.segmentDistribution.options);
      this.segmentDistribution.instance.redraw();
    });

  }

  penetrationLoyaltyInit (data) {

    Observable.zip (
      this.indicatorService.getChart('stores.Q146', data, false),
      this.indicatorService.getChart('stores.Q146B', data, false)
    ).subscribe( ([res, resMedia]) => {

      let serie0 = resMedia.series[0].serie.concat(res.series[0].serie);
      let serie1 = resMedia.series[1].serie.concat(res.series[1].serie);
      let series: Array<any> = [];
      let categories: Array<string> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i], color: '#26437a'} );
        categories.push(series[i].name);
      }

      this.penetrationLoyalty.options.chart.height = this.computeHeight(series.length);

      if (this.penetrationLoyalty.instance) {
        while (this.penetrationLoyalty.instance.series.length > 0) {
          this.penetrationLoyalty.instance.series[0].remove(true);
        }
      }

      this.penetrationLoyalty.options.chart.marginBottom = 130;

      this.penetrationLoyalty.options.series = [{ name: 'Penetration Loyalty', colorByPoint: true, data: series }];
      this.penetrationLoyalty.instance.addSeries(series);
      this.penetrationLoyalty.instance.update(this.penetrationLoyalty.options);
      this.penetrationLoyalty.instance.redraw();

    });
  }

  resetData() {
    this.show_results = false;
  }

  computeHeight(len: number) {
    const f = 5;
    return (len * f * 10) + ((f * 100) / len);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/list-customer-value/list-customer-value.component.ts